import LetterAvatar from "@/components/Avatar/LetterAvatar"
import { formatToDevanagariStyle } from "@/utilities/helper"

export const columns = [
  {
    header: "SKU",
    accessorKey: "sku",
  },
  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "code",
    accessorKey: "code",
  },
  {
    header: "Stock",
    accessorKey: "stock",
  },
  {
    header: "Price",
    cell: ({ row }) =>
      `Rs. ${formatToDevanagariStyle(row.original.sell_price)}`,
  },
]
